import React, { Component } from 'react';

class Summary extends Component { 
  render() {
    return (
      <div className='game-summary'>
        <h3 className='game-summary-title site-border-color'>Game Summary</h3>
        <div className='game-wrapper'>
          {this.props.gameStats.map((item, i) => (
            <div className='team' key={i}>
              <span className='team-name'>{i < 1? this.props.awayTeam.mascot : this.props.homeTeam.mascot}</span>
              {this.props.headers[0].map((header, i) => (
                <div key={i}>
                  <span>{header}</span>
                  <span><b>{item[this.props.headers[1][i]] || 'N/A'}</b></span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default Summary;